module.exports = __webpack_public_path__ + "img/49.1d81acfa.png";